import React, { Component } from 'react'
import $ from 'jquery'
import {
	Table,
	TableContainer,
	TableHead,
	TableRow,
	TableBody,
} from '@material-ui/core'
import { StyledTableCell } from '../../commons/utils/TableStyles'
import { FormattedMessage } from 'react-intl'
import * as Utils from '../../commons/utils/Utils.js'
import Timezone from '../../commons/timezone/Timezone.js'
import * as Constants from '../atributoDinamico/constants.js'

const COMENTARIO_PREVIEW_LENGTH = 60;

// VEC-3476: histórico de validaciones (VEC-3362, tabla valor_dinamico_validaciones)
// de los ítems de "Mínimo Vital" de un checklist, en un modal (mismo patrón visual
// que HistoricoDatosGeneralesGrid.jsx en Móviles: Table de Material-UI dentro de un
// modal-xl) en vez del popover chico que se probó primero.
class MinimoVitalHistorialModal extends Component {
	constructor(props) {
		super(props);
		this.modalId = 'modal_minimo_vital_historial_' + props.formularioId;
		this.state = {
			loading: true,
			historial: [],
			expandidos: {},
		};
	}

	componentDidMount() {
		let component = this;
		$('#' + this.modalId).modal({ backdrop: 'static' });
		$('#' + this.modalId).on('hidden.bs.modal', function () {
			component.props.onClose();
		});
		this.cargarHistorial();
	}

	componentWillUnmount() {
		$('#' + this.modalId).off('hidden.bs.modal');
	}

	cargarHistorial() {
		let component = this;
		Utils.getData('/formulario/' + this.props.formularioId + '/minimo-vital/historial').then(function (data) {
			component.setState({ historial: data || [], loading: false });
		}).catch(function () {
			component.setState({ loading: false });
		});
	}

	toggleExpandido(id) {
		this.setState(function (prevState) {
			let expandidos = Object.assign({}, prevState.expandidos);
			expandidos[id] = !expandidos[id];
			return { expandidos: expandidos };
		});
	}

	labelDecision(decision) {
		let intl = this.props.intl;
		if (decision === Constants.ID_DECISION_VALIDO) {
			return intl.formatMessage({ id: 'formularios.minimoVital.historial.decision_valido', defaultMessage: 'Resuelto' });
		}
		if (decision === Constants.ID_DECISION_INVALIDO) {
			return intl.formatMessage({ id: 'formularios.minimoVital.historial.decision_invalido', defaultMessage: 'Rechazado' });
		}
		return intl.formatMessage({ id: 'formularios.minimoVital.historial.decision_cancelado', defaultMessage: 'Reabierto' });
	}

	renderComentario(item) {
		let motivo = item.motivo;
		if (!motivo) return '-';
		if (motivo.length <= COMENTARIO_PREVIEW_LENGTH) return motivo;

		let expandido = !!this.state.expandidos[item.id];
		return (
			<span>
				{expandido ? motivo : motivo.substring(0, COMENTARIO_PREVIEW_LENGTH) + '...'}
				{' '}
				<button type="button" className="btn btn-sm btn-link p-0" onClick={() => this.toggleExpandido(item.id)}>
					{expandido
						? <FormattedMessage id="formularios.minimoVital.historial.ver_menos" defaultMessage="ver menos" />
						: <FormattedMessage id="formularios.minimoVital.historial.ver_mas" defaultMessage="ver más" />
					}
				</button>
			</span>
		);
	}

	render() {
		let historial = this.state.historial;

		return (
			<div className="modal fade" tabIndex="-1" id={this.modalId} role="dialog" aria-labelledby={this.modalId + '_label'}>
				<div className="modal-xl modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header bg-fleet">
							<h4 className="modal-title text-white" id={this.modalId + '_label'}>
								<FormattedMessage id="formularios.minimoVital.historial.titulo" defaultMessage="Historial de Mínimo Vital" />
							</h4>
							<button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						</div>
						<div className="modal-body modal-mh ovf-x-hidden">
							<TableContainer>
								<Table aria-label="minimo vital historial table">
									<TableHead>
										<TableRow>
											<StyledTableCell align="left">
												<FormattedMessage id="formularios.minimoVital.historial.col_item" defaultMessage="Ítem" />
											</StyledTableCell>
											<StyledTableCell align="left">
												<FormattedMessage id="formularios.minimoVital.historial.col_decision" defaultMessage="Decisión" />
											</StyledTableCell>
											<StyledTableCell align="left">
												<FormattedMessage id="formularios.minimoVital.historial.col_comentario" defaultMessage="Comentario" />
											</StyledTableCell>
											<StyledTableCell align="left">
												<FormattedMessage id="formularios.minimoVital.historial.col_usuario" defaultMessage="Usuario" />
											</StyledTableCell>
											<StyledTableCell align="left">
												<FormattedMessage id="formularios.minimoVital.historial.col_fecha" defaultMessage="Fecha" />
											</StyledTableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{this.state.loading && (
											<TableRow>
												<StyledTableCell colSpan={5} align="center">
													<i className="fa fa-spinner fa-spin"></i>
												</StyledTableCell>
											</TableRow>
										)}
										{!this.state.loading && historial.length === 0 && (
											<TableRow>
												<StyledTableCell colSpan={5} align="center">
													<FormattedMessage id="formularios.minimoVital.historial.vacio" defaultMessage="Sin historial todavía." />
												</StyledTableCell>
											</TableRow>
										)}
										{!this.state.loading && historial.map((item) => {
											let nombre = item.valor_dinamico_snapshot && item.valor_dinamico_snapshot.atributo_dinamico
												? item.valor_dinamico_snapshot.atributo_dinamico.nombre
												: '';
											let usuario = item.usuario_validador ? item.usuario_validador.label : '';
											return (
												<TableRow key={item.id}>
													<StyledTableCell align="left">{nombre}</StyledTableCell>
													<StyledTableCell align="left" className={item.decision === Constants.ID_DECISION_INVALIDO ? 'danger' : 'success'}>
														{this.labelDecision(item.decision)}
													</StyledTableCell>
													<StyledTableCell align="left">{this.renderComentario(item)}</StyledTableCell>
													<StyledTableCell align="left">{usuario}</StyledTableCell>
													<StyledTableCell align="left">{Timezone.getDateForClient(item.created_at, null, 'DD/MM/YYYY HH:mm')}</StyledTableCell>
												</TableRow>
											);
										})}
									</TableBody>
								</Table>
							</TableContainer>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-default btn-fleet" data-dismiss="modal">
								<FormattedMessage id="formularios.minimoVital.historial.boton_cerrar" defaultMessage="Ok" />
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default MinimoVitalHistorialModal
